import { MonitorSignal } from '../../services/stockMonitorService';
import { getEncoding } from 'js-tiktoken';

const tokenizer = getEncoding('cl100k_base');

// 估算token数量 (使用 js-tiktoken)
export const estimateTokenCount = (text: string): number => {
  if (!text) return 0;
  try {
    const tokens = tokenizer.encode(text);
    return tokens.length;
  } catch (error) {
    console.warn('js-tiktoken encoding failed, fallback to simple estimation:', error);
    // Fallback: 简单方法
    const chineseChars = (text.match(/[\u4e00-\u9fa5\u3000-\u303f\uff00-\uffef]/g) || []).length;
    const otherChars = text.length - chineseChars;
    return Math.ceil(chineseChars / 1.5 + otherChars / 4);
  }
};

// 格式化价格
export const formatPrice = (price: number | undefined): string => {
  if (price === 0 || !price) return '-';
  if (price < 0.01) return price.toFixed(6);
  if (price < 1) return price.toFixed(4);
  return price.toFixed(2);
};

// 获取信号状态显示
export const getSignalStatus = (signals: MonitorSignal[] | undefined) => {
  if (!Array.isArray(signals)) {
    return { triggeredCount: 0, totalCount: 0 };
  }
  const triggeredCount = signals.filter((s) => s.triggered).length;
  const totalCount = signals.length;
  return { triggeredCount, totalCount };
};
